import { create } from "zustand";

export const useNotificadoresStore = create((set) => ({
  actas: null,
  notifiacores: null,
  notificadorSelect: null,
  motivos: null,
  filterActasEstado: "No notificadas",
  order: {
    orderBy: "des",
    // orderField: "fecha_hora",
    orderField: "id",
  },
  filter: { estado_id: "No notificadas" },
  // in:reparto,notificadas,no-notificadas
  filterEstado: "no-notificadas",
  buscar: "",
  paginateCfg: null,
  filterReporteNotificadores: null,
  reporteNotificador: null,
  actasSeleccionadas: null,
  fechasReporte: {
    fecha_desde: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    fecha_hasta: new Date(),
  },

  actasRelacionadas: null,
  submitFilter: false,

  setSubmitFilter: (submitFilter) => {
    set({ submitFilter: submitFilter });
  },
  setActas: (actas) => {
    set({ actas: actas });
  },

  setPaginateCfg: (cfg) => {
    // console.log(cfg)
    set({ paginateCfg: cfg });
  },

  setBuscar: (buscar) => {
    set({ buscar });
  },
  setFilterEstado: (estado) => {
    set({ filterEstado: estado , reporteNotificador: null });
  },
  setOrder: (orderBy, orderField) => {
    // set({ orderBy: order });
    set({ order: { orderBy, orderField } });
  },

  setNotificadores: (notificadores) => {
    set({ notificadores: notificadores });
  },
  setNotificadorSelect: (notificador) => {
    set({ notificadorSelect: notificador });
  },

  setMotivos: (motivos) => {
    set({ motivos: motivos });
  },

  setFilterActasEstado: (estado) => {
    set({
      filterActasEstado: estado,
      filter: {
        estado_id: estado,
      },
    });
  },

  setFilterFields: (fieldName, value) => {
    set((state) => ({
      filterFields: {
        ...state.filterFields,
        [fieldName]: value,
      },
    }));
  },

  setActasRelacionadas: (actas) => {
    set({ actasRelacionadas: actas });
  },

  setFilterReporteNotificadores: (filtros) => {
    set({ filterReporteNotificadores: filtros });
  },
  setReporteNotificador: (reporte) => {
    set({ reporteNotificador: reporte });
  },
  setFechasReporte: (fechaDesde, fechaHasta) => {
    set({ fechasReporte: { fecha_desde: fechaDesde, fecha_hasta: fechaHasta } });
  },
  setActasSeleccionadas: (actas) => {
    set({ actasSeleccionadas: actas });
  },
}));
